import { Optional } from '@vimeo/core/types/generic';

import { environmentConfig } from '../../configs/EnvironmentConfig';

/**
 * Notes:
 * - In safari private mode referrer is replaced with an empty string
 * - `ancestorOrigins` is not supported by all browsers and used as fallback option
 *
 * @returns current page referrer (parent URL) if it is in iframe or null
 */
export function getIframeReferrer(): Optional<string> {
  if (!environmentConfig.IS_IFRAME) {
    return null;
  } else if (window?.document.referrer) {
    return window.document.referrer;
  } else if (window?.document.location?.ancestorOrigins?.length) {
    return window?.document.location?.ancestorOrigins[0];
  }

  return null;
}
